import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import type { VisibleDay } from "@/views/planning/type";

dayjs.extend(isBetween);

export const DATE_FORMAT = "YYYY-MM-DD";

export const getPlanningPeriodStartDate = (
  periodOffset: number,
  periodLengthInDays = 7,
) => {
  return dayjs()
    .startOf("week")
    .add(1, "day")
    .add(periodOffset * periodLengthInDays, "day")
    .format(DATE_FORMAT);
};

export const getPlanningPeriodEndDate = (
  startDate: string,
  periodLengthInDays = 7,
) => {
  return dayjs(startDate)
    .add(periodLengthInDays - 1, "day")
    .format(DATE_FORMAT);
};

export const getVisibleDays = (
  startDate: string,
  periodLengthInDays = 10,
): VisibleDay[] => {
  const days: VisibleDay[] = [];
  let currentDate = dayjs(startDate);

  while (days.length < periodLengthInDays) {
    const dayOfWeek = currentDate.day();
    // Skip Saturday (6) and Sunday (0)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      days.push({
        date: currentDate.format(DATE_FORMAT),
        dayName: currentDate.format("ddd"),
        dayDate: currentDate.date(),
        dayOfWeek,
        monthLabel: currentDate.format("MMM"),
      });
    }
    currentDate = currentDate.add(1, "day");
  }

  return days;
};

export const getPlanningPeriodLabel = (visibleDays: VisibleDay[]) => {
  if (visibleDays.length === 0) {
    return "";
  }

  const firstDay = visibleDays[0];
  const lastDay = visibleDays[visibleDays.length - 1];

  return `${firstDay.dayName} ${firstDay.dayDate} - ${lastDay.dayName} ${lastDay.dayDate}`;
};

export const isToday = (date: string) => {
  return dayjs(date).isSame(dayjs(), "day");
};

export const isDateInRange = (
  date: string,
  startDate: string,
  endDate: string,
) => {
  return dayjs(date).isBetween(startDate, endDate, "day", "[]");
};
